export const SET_RETURNS = 'SET_RETURNS';
export const SET_LOADING_RETURN_ID = 'SET_LOADING_RETURN_ID';
export const SELECT_RETURN = 'SELECT_RETURN';
export const SET_SEARCH_RETURNS_ACTION = 'SET_SEARCH_RETURNS_ACTION';
export const SET_SEARCH_RETURNS_QUERY = 'SET_SEARCH_RETURNS_QUERY';
export const CLEAR_RETURNS = 'CLEAR_RETURNS';
export const CLEAR_RETURNS_SEARCH_STATE = 'CLEAR_RETURNS_SEARCH_STATE';
